import React from 'react';
import { Link, NavLink } from 'react-router-dom'
import SearchInput from './SearchInput';

const HeaderTwo = () => {
    return (
        <>
            <div className='header-section'>
                <div className='section-container'>
                    <header className="header">
                        <div className='img-fluid '>
                            <Link to={"/"}><img className="logo" src={'assets/images/fundi_tz_logo_high_res_1final 1.png'} alt="Fundi Logo" /></Link>
                        </div>
                        <div>
                            <nav className="navbar">
                                <ul>
                                    <li><NavLink to="/" style={({ isActive }) => ({ color: isActive ? '#28A745' : '#666666'})}>Home</NavLink> </li>
                                    <li><NavLink to="/job"  style={({ isActive }) => ({ color: isActive ? '#28A745' : '#666666'})}>Jobs</NavLink> </li>
                                    <li><NavLink to="/"  style={({ isActive }) => ({ color: isActive ? '#28A745' : '#666666'})}>Notification</NavLink> </li>
                                    
                                    <li><button className="btt-post"><NavLink to="/job-post"  style={({ isActive }) => ({ color: isActive ? '#ffffff' : '#666666'})}>Post a Job</NavLink></button></li>
                                    {/* <li><div className='searchinput'><input  type="text" placeholder='Enter Your Bid No.' /> <span className='searchspan'><IoSearch className='bidsearch'/></span></div></li>
                                     */}
                                    <li><SearchInput/></li>
                                    <li className='globle-li'><span><img width="21px" height="23px" src={`assets/images/icons/Vector.png`} alt="" /></span> </li>
                                    <li className='nav-login'> <span> <img width="20px" height="17px" src={'assets/images/icons/Vector2.png'} alt=""  /> </span> </li>
                                    <li className='nav-login'> <span> <img width="41px" height="41px" src={'assets/images/icons/Group.png'} alt="" /> </span> </li>

                                </ul>
                            </nav>
                        </div>

                    </header>
                </div>

            </div>

        </>
    )
}

export default HeaderTwo;